import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
  tw: {
    button: {
      createTheNewApplication: '新增假單',
      reselectTheLeavingDay: '重新選擇請假日期',
      applicationTracking: '查詢申請進度',
      selectAll: '選擇全部',
      clearAll: '清除全部',
      save: '存檔',
      confirm: '確定',
      backToTheRegularPage: '回說明事項',
    },
    $vuetify: {
      dataIterator: {
        rowsPerPageText: 'Element per sida:',
        pageText: '{0}-{1} av {2}',
      },
    },
    message: {
      hello: '你好',
    },
  },
  en: {
    button: {
      createTheNewApplication: 'Create the new application',
      reselectTheLeavingDay: 'Reselect the leaving day',
      applicationTracking: 'Application tracking',
      selectAll: 'Select all',
      clearAll: 'Clear all',
      save: 'save',
      confirm: 'Confirm',
      backToTheRegularPage: 'Back to the regular page',
    },
    $vuetify: {
      dataIterator: {
        rowsPerPageText: 'Items per page:',
        pageText: '{0}-{1} of {2}',
      },
    },
    message: {
      hello: 'hello',
    },
  },
  ja: {
    $vuetify: {
      dataIterator: {
        rowsPerPageText: 'Element per sida:',
        pageText: '{0}-{1} av {2}',
      },
    },
    message: {
      hello: 'こんにちは',
    },
  },
};

const lang = localStorage.getItem('language') || 'tw';

const i18n = new VueI18n({
  locale: lang,
  messages,
});

export default i18n;
